<!-- 权限分配 -->
<template>
  <div>
    <!-- <div class="data-title">用户列表</div> -->
    <div class="select-box clearfix">
      <div class="item-select-box li-width">
        <span class="item-select-title item-select-title-4">关键词：</span>
        <div class="item-select-content">
          <el-input v-model="selectenObj.keyWord" placeholder="请输入公司名称或联系人姓名" clearable></el-input>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="item-select-box li-min-width">
        <span class="item-select-title item-select-title-4">公司类型：</span>
        <div class="item-select-content">
          <el-select v-model="selectenObj.companyType" placeholder="请选择">
            <el-option
              v-for="(item,index) in lxOptions"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="item-select-box li-min-width">
        <span class="item-select-title item-select-title-4">用户类型：</span>
        <div class="item-select-content">
          <el-select v-model="selectenObj.userType" placeholder="请选择">
            <el-option
              v-for="(item,index) in yhOptions"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="item-select-box">
        <span class="item-select-title item-select-title-4">剩余金额(万元)：</span>
        <div class="item-select-content range-box clearfix">
          <el-input v-model="selectenObj.startAccountAmount" placeholder="请输入" clearable></el-input>
          <span class="range-span">-</span>
          <el-input v-model="selectenObj.endAccountAmount" placeholder="请输入" clearable></el-input>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="item-select-box">
        <span class="item-select-title">付费方式：</span>
        <div class="item-select-content">
          <el-select v-model="selectenObj.paymentMethod" placeholder="请选择">
            <el-option
              v-for="(item,index) in paymentMethodOptions"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="clearfix"></div>
      <a @click="selectFun()" class="select-box-btn">查询</a>
    </div>
    <div class="result-box">
      <div class="result-box-title clearfix">
        <p>共<span>{{resultDataTotal}}</span>个用户</p>
      </div>
      <div class="result-box-content clearfix">
        <el-table
          :data="resultData"
          border
          header-row-class-name="tableHead"
          style="width: 100%">
          <el-table-column
            label="序号"
            align="center"
            width="50">
            <template slot-scope="scope">
              {{(currentPage-1)*pagesize+scope.$index+1}}
            </template>
          </el-table-column>
          <el-table-column
            label="公司名称"
            prop="comName"
            width="308">
          </el-table-column>
          <el-table-column
            prop="comType"
            label="公司类型"
            width="100">
          </el-table-column>
          <el-table-column
            prop="channelName"
            label="渠道名"
            width="140">
          </el-table-column>
          <el-table-column
            prop="userStatus"
            label="当前状态"
            width="90">
          </el-table-column>
          <el-table-column
            label="付费方式"
            width="100">
            <template slot-scope="scope">
              {{$common.toStr1(scope.row.paymentType,dictionary.payment_type)}}
            </template>
          </el-table-column>
          <el-table-column
            label="到期日期"
            width="110">
            <template slot-scope="scope">
              <span v-if="scope.row.endTime">{{scope.row.endTime}}</span>
              <span v-if="!scope.row.endTime">-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="testToken"
            label="SIT环境Token"
            width="270">
          </el-table-column>
          <el-table-column
            prop="userToken"
            label="上线Token"
            width="280">
          </el-table-column>
          <el-table-column
            label="操作"
            width="190">
            <template slot-scope="scope">
              <a v-if="scope.row.isFlag==1" @click="detailsFun(scope.row.userId,scope.row.paymentType)">查看</a>
              <div class="buttom-box" v-if="userInfo.comType=='1' || userInfo.id!=scope.row.userId">
                <a v-if="scope.row.isFlag==1" @click="editFun(scope.row.userId,scope.row.paymentType)">修改</a>
                <div class="buttom-inner-box" v-if="scope.row.isFlag==1">
                  <a v-if="scope.row.paymentType=='1'" @click="rechargeFun(scope.row.userId,'1')">充值</a>
                  <a v-if="scope.row.paymentType=='2'" @click="rechargeFun(scope.row.userId,'2')">后付费</a>
                </div>
                <div class="buttom-inner-box" v-if="scope.row.isFlag!=1">
                  <a @click="rechargeFun(scope.row.userId,'1')">充值</a>
                  <a @click="rechargeFun(scope.row.userId,'2')">后付费</a>
                </div>
                <a v-if="scope.row.isFlag==1 && scope.row.freezeStatus==2" @click="frozenOrOnlineFun(scope.row.userId,scope.row.freezeStatus)">冻结</a>
                <a v-if="scope.row.isFlag==1 && scope.row.freezeStatus!=2" @click="frozenOrOnlineFun(scope.row.userId,scope.row.freezeStatus)">上线</a>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination v-if="resultDataTotal>10"
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pagesize"
          :total="resultDataTotal">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import vue from 'vue'
export default {
  name: 'UserManagement',
  data () {
    return {
      userInfo:JSON.parse(localStorage.getItem('UserInfo')),
      selectenObj:{
        keyWord:'',
        companyType:'',
        userType:'',
        startAccountAmount:'',
        endAccountAmount:'',
        paymentMethod:''
      },
      dictionary:JSON.parse(localStorage.getItem('dictionary')),
      resultDataTotal:0,
      currentPage:1,
      pagesize:10,
      resultData: [],
      lxOptions:[],
      yhOptions:[],
      paymentMethodOptions:[]
    }
  },
  mounted () {
    var _this=this;
    var allObj=new Object();
    allObj.name="全部";
    allObj.value="";
    _this.lxOptions.push(allObj);
    _this.dictionary.com_type.forEach(function(item){
      _this.lxOptions.push(item);
    });
    _this.yhOptions.push(allObj);
    _this.dictionary.user_type.forEach(function(item){
      _this.yhOptions.push(item);
    });
    _this.paymentMethodOptions.push(allObj);
    _this.dictionary.payment_type.forEach(function(item){
      _this.paymentMethodOptions.push(item);
    });
    _this.clickSelectFun();
  },
  methods:{
    // 分页
    handleCurrentChange:function(val) {
      var _this=this;
      _this.currentPage = val;
      _this.clickSelectFun();
    },
    clickSelectFun: function(){
      var _this=this;
      if(!this.$common.isNum(_this.selectenObj.startAccountAmount) && _this.selectenObj.startAccountAmount!=''){
        _this.$message("请检查剩余额度输入");
      }else if(!this.$common.isNum(_this.selectenObj.endAccountAmount) && _this.selectenObj.endAccountAmount!=''){
        _this.$message("请检查剩余额度输入");
      }else{
        var terms=new Object();
        //关键字
        terms.keyWord=_this.selectenObj.keyWord;
        //公司类型
        terms.comType=_this.selectenObj.companyType;
        //用户类型
        terms.userType=_this.selectenObj.userType;
        //付费方式
        terms.paymentType=_this.selectenObj.paymentMethod;
        //剩余金额
        if(_this.selectenObj.startAccountAmount==''){
          terms.startAccountAmount='';
        }else{
          terms.startAccountAmount=_this.selectenObj.startAccountAmount*10000;
        };
        if(_this.selectenObj.endAccountAmount==''){
          terms.endAccountAmount='';
        }else{
          terms.endAccountAmount=_this.selectenObj.endAccountAmount*10000;
        };
        
        terms.page=_this.currentPage;
        terms.pageSize=_this.pagesize;
        // console.log("terms==================="+JSON.stringify(terms));
        _this.$axios.post('/requestApi/recharge/list',terms)      
        .then(function(response){
          let data = response.data;
          // console.log("data==================="+JSON.stringify(data));
          if(data.meta.retCode==0){
            _this.resultDataTotal=data.data.totalCount;
            _this.resultData=data.data.resultList;
          }else{
            console.log(data.meta.friendlyMsg);
          }
        })
        .catch(function(error){
          console.log(error)
        });
      }
    },
    // 查询数据
    selectFun: function(){
      var _this=this;
      _this.currentPage=1;
      _this.clickSelectFun();
    },
    //查看
    detailsFun: function(id,type){
      if(type=='2'){
        this.$router.push({ path: '/PermissionDetailAfterpay', query: {id: id} });
      }else{
        this.$router.push({ path: '/PermissionDetailPrepay', query: {id: id} })
      }
    },
    //修改(与充值页面一致)
    editFun: function(id,type){
      if(type=='2'){
        this.$router.push({ path: '/RechargePageAfterpay', query: {id: id,type:'edit'} });
      }else{
        this.$router.push({ path: '/RechargePagePrepay', query: {id: id,type:'edit'} });
      }
    },
    //充值
    rechargeFun: function(id,type){
      if(type=='2'){
        this.$router.push({ path: '/RechargePageAfterpay', query: {id: id,type:'add'} });
      }else{
        this.$router.push({ path: '/RechargePagePrepay', query: {id: id,type:'add'} });
      }
    },
    //上线\下线
    frozenOrOnlineFun: function(id,state){
      var _this=this;
      var title='';
      var tishi='';
      var result='';
      if(state==2){
        title='确认冻结';
        tishi='是否确认正式冻结？';
        result='已冻结';
      }else if(state!=2){
        title='确认上线';
        tishi='是否确认正式上线？';
        result='已上线';
      };
      _this.$confirm(tishi, title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$axios.post('/requestApi/freezeOrOnline?userId='+id)      
          .then(function(response){
            let data = response.data;
            if(data.meta.retCode==0){
              _this.$message({
                type: 'success',
                message: result
              });
              _this.clickSelectFun();
            }else{
              console.log(data.meta.friendlyMsg);
            }
          })
          .catch(function(error){
            console.log(error)
          });
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消'
        });          
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.buttom-box,.buttom-inner-box{display: inline-block;}
</style>



// WEBPACK FOOTER //
// src/components/PermissionAssignment.vue